export default function cryptString(string: string) {
    var cryptedString: string = "";
    var multiplicator: number = 1;
    var currentChar: number = 33;
    for (var i: number = 0; i < string.length; i++) {
        multiplicator = multiplicator * 3.25 / 9.652 * 5.647;
        currentChar = string[i].charCodeAt(0);
        currentChar *= Math.round(multiplicator);
        currentChar %= 89;
        currentChar += 33;
        cryptedString = cryptedString.concat(String.fromCharCode(currentChar));
    }
    return cryptedString;
}